export default __webpack_public_path__ + "static/project-slide-1-2016-765-787f1de1f493a94a1a080359af859dde.webp";